exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".events .event {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .events .event .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .events .event:hover {\n    cursor: pointer; }\n    .events .event:hover .item-actions {\n      opacity: 1; }\n  .events .event:hover {\n    background-color: #fcf9f3; }\n  .events .event .title {\n    font-weight: bold; }\n  .events .event .location {\n    color: #2455a5;\n    margin-bottom: 0.5rem; }\n  .events .event .description {\n    color: #898a8e;\n    margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar/event-list/event-list.component.scss
// module id = 387
// module chunks = 0